import { authFetch, previewFetch } from './api';

export const fetchAlbums = async () => {
  const response = await previewFetch('/api/albums');
  if (!response.ok) throw new Error('Erreur lors du chargement du catalogue');
  return response.json();
};

export const fetchAlbum = async (id, isArtistView = false) => {
  // Use authenticated endpoint for artist dashboard, public endpoint for fan view
  const response = isArtistView
    ? await authFetch(`/api/artists/me/albums/${id}`)
    : await previewFetch(`/api/albums/${id}`);
  
  const result = await response.json();

  if (!response.ok) {
    throw new Error(result.message || 'Album introuvable');
  }

  return result;
};

export const createAlbum = async (payload) => {
  const response = await authFetch('/api/artists/me/albums', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || 'Impossible de creer la release.');
  }
  return result;
};

export const updateAlbum = async (id, payload) => {
  const response = await authFetch(`/api/artists/me/albums/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || 'Impossible de modifier la release.');
  }
  return result;
};

export const deleteAlbum = async (id) => {
  const response = await authFetch(`/api/artists/me/albums/${id}`, {
    method: 'DELETE'
  });

  const result = await response.json();
  if (!response.ok) {
    throw new Error(result.message || 'Impossible de supprimer la release.');
  }
  return result;
};
